import reducer from "./reducers";

import * as emailFrequencyOperations from "./operations";

export { emailFrequencyOperations };

export default reducer;